<script>
export default {
  name: "KolonneSettingsAssignedVehicle",

  props: {
    vehicle: {
      type: Object | null,
      default: null
    },
    selectedKolonneId: {
      type: Number | String,
      default: ''
    },
    startdate: {
      type: String, // format "YYYY-MM-DD"
      default: '',
    },
    kolonneContent: {
      type: Array,
      default: () => [],
    },
    hideRanking: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    shouldShowCategoryName () {
      return !!this.vehicle.categoryName && this.vehicle.name !== this.vehicle.categoryName;
    },

    ranking () {
      if (this.isAssignedInOtherKolonne) {
        return 'red';
      }

      return undefined;
    },

    rankingMessage () {
      if (this.isAssignedInOtherKolonne) {
        return `${this.$t('kolonne.label.assigned.to.other.kolonnen')} ${this.assignedKolonneNumbers.join(', ')}`
      }

      return 'ist verfügbar';
    },

    isAssignedInOtherKolonne () {
      return this.assignedKolonneNumbers.length > 1;
    },

    assignedKolonneNumbers () {
      return this.kolonneContent
        .filter(content => [].concat(content.fleet_ids ?? []).includes(this.vehicle.id))
        .map(content => content.kolonne);
    },
  },
};
</script>

<template>
  <div class="c-crew-settings-box__item">
    <div class="c-crew-settings-box__item-ranking">
        <span
        v-if="!hideRanking"
        :title="rankingMessage"
        :class="'c-ranking c-ranking--' + (ranking || 'transparent') ">
        </span>
    </div>
    <div class="c-crew-settings-box__item-name">
     {{ vehicle.displayName }}
     <template v-if="shouldShowCategoryName">
       <span
        class="u-text-medium"
      >
        – {{ vehicle.category }}
      </span>
     </template>   
    </div>
  </div>
</template>

